import { useState } from "react";
import { useDrawDetails } from "../../context/draw-details";
import { NotificationBar } from "@asosteam/asos-web-component-library-notification-bar";
import styles from "./styles";
import global from "../../styles";

export default function Notifications() {
  const [state] = useDrawDetails();
  const { notifications } = state;

  return (
    <>
      {notifications && (
        <div className={styles.container}>
          {notifications.map((notification) => {
            const DismissableNotification = () => {
              const [isHidden, setIsHidden] = useState(false);

              return (
                !isHidden && (
                  <NotificationBar
                    onClose={() => setIsHidden(true)}
                    type={notification.type}
                    hasIcon={false}
                  >
                    <h2 className={global.london1}>{notification.title}</h2>
                    <p className={global.leavesden3}>{notification.message}</p>
                    {notification.link && (
                      <a
                        href={notification.link?.href}
                        className={global.london3}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {notification.link?.text}
                      </a>
                    )}
                  </NotificationBar>
                )
              );
            };

            return (
              <DismissableNotification
                key={notification.title + notification.message}
                notification={notification}
              />
            );
          })}
        </div>
      )}
    </>
  );
}
